module.exports = __webpack_public_path__ + "img/小狗-2.140948fe.jpg";